/* fjor — Hydrolytic scroll sequence (v9). window.HxSeq(rootEl) boots one instance. */
window.HxSeq = function (root) {
  if (!root || root.dataset.hxInit) return;
  root.dataset.hxInit = "1";

  var cv = root.querySelector("[data-hx=canvas]");
  var caps = root.querySelector("[data-hx=caps]");
  var meter = root.querySelector("[data-hx=meter]");
  var rail = root.querySelector("[data-hx=rail]");
  var hint = root.querySelector("[data-hx=hint]");
  var scrim = root.querySelector("[data-hx=scrim]");
  var ctx = cv.getContext("2d");
  var N = 6, p = 0, t = 0, dpr = 1, W = 1, H = 1, raf = 0, plate = null, noisePat = null;
  var PLATE_SRC = root.dataset.plate;
  var INTRO_SRC = root.dataset.intro;
  var intro = null;
  var SHOW_METER = root.dataset.meter === "true";

  function isMobile() { return window.innerWidth < 760; }
  function smooth(v) { v = Math.min(1, Math.max(0, v)); return v * v * (3 - 2 * v); }
  function track(pp, keys) {
    if (pp <= keys[0][0]) return keys[0][1];
    for (var i = 1; i < keys.length; i++) {
      if (pp <= keys[i][0]) {
        var a = keys[i - 1][0], av = keys[i - 1][1], b = keys[i][0], bv = keys[i][1];
        return av + (bv - av) * smooth((pp - a) / (b - a));
      }
    }
    return keys[keys.length - 1][1];
  }
  function rgba(hex, a) {
    var n = parseInt(hex.slice(1), 16);
    return "rgba(" + (n >> 16 & 255) + "," + (n >> 8 & 255) + "," + (n & 255) + "," + a + ")";
  }

  // ---- sprites ------------------------------------------------------------
  var spr = { flora: [], harm: [], film: null, noise: null };
  function mkOrganism(aspect, base, light, grains) {
    var S = 168, c = document.createElement("canvas");
    c.width = c.height = S;
    var x = c.getContext("2d"), cx = S / 2, cy = S / 2;
    var rx = S * 0.43, ry = S * 0.43 / aspect;
    var g = x.createRadialGradient(cx, cy, 0, cx, cy, S * 0.5);
    g.addColorStop(0, rgba(light, 0.1));
    g.addColorStop(0.5, rgba(light, 0.05));
    g.addColorStop(1, rgba(light, 0));
    x.fillStyle = g; x.fillRect(0, 0, S, S);
    x.save(); x.translate(cx, cy); x.scale(1, 1 / aspect);
    g = x.createRadialGradient(0, 0, 0, 0, 0, rx);
    g.addColorStop(0, rgba(base, 0.26));
    g.addColorStop(0.6, rgba(base, 0.32));
    g.addColorStop(0.87, rgba(base, 0.19));
    g.addColorStop(1, rgba(base, 0));
    x.fillStyle = g; x.beginPath(); x.arc(0, 0, rx, 0, 6.283); x.fill(); x.restore();
    x.save();
    x.beginPath(); x.ellipse(cx, cy, rx * 0.93, ry * 0.93, 0, 0, 6.283); x.clip();
    for (var i = 0; i < grains; i++) {
      var a = Math.random() * 6.283, rr = Math.sqrt(Math.random());
      x.fillStyle = Math.random() > 0.52 ? "rgba(22,32,15,0.15)" : rgba(light, 0.2);
      x.beginPath();
      x.arc(cx + Math.cos(a) * rx * 0.9 * rr, cy + Math.sin(a) * ry * 0.9 * rr, 0.5 + Math.random() * 1.7, 0, 6.283);
      x.fill();
    }
    x.strokeStyle = rgba(light, 0.18); x.lineWidth = 2.4;
    x.beginPath(); x.ellipse(cx, cy, rx * 0.9, ry * 0.9, 0, 0, 6.283); x.stroke();
    x.restore();
    return c;
  }
  function makeSprites() {
    var greens = [["#3E5531", "#BCD49E"], ["#4C6A3A", "#D2E4B4"], ["#5F7A46", "#DEEAC8"]];
    for (var i = 0; i < 6; i++) {
      var g = greens[i % 3];
      spr.flora.push(mkOrganism(i < 3 ? 2.8 : 1, g[0], g[1], 300));
    }
    for (var j = 0; j < 3; j++) spr.harm.push(mkOrganism(j === 2 ? 1.9 : 1, "#9E3A22", "#EDB49C", 220));

    var F = 620, fc = document.createElement("canvas");
    fc.width = fc.height = F;
    var fx = fc.getContext("2d"), cxf = F / 2, cyf = F / 2, s = 77771;
    var rnd = function () { s = (s * 1664525 + 1013904223) % 4294967296; return s / 4294967296; };
    for (var k = 0; k < 230; k++) {
      var a = rnd() * 6.283, rr = Math.pow(rnd(), 0.5);
      var lx = cxf + Math.cos(a) * F * 0.33 * rr, ly = cyf + Math.sin(a) * F * 0.28 * rr;
      var lr = F * (0.03 + rnd() * 0.06) * (1.1 - rr * 0.4);
      var gg = fx.createRadialGradient(lx, ly, 0, lx, ly, lr);
      gg.addColorStop(0, "rgba(96,88,76,0.3)");
      gg.addColorStop(0.5, "rgba(112,104,90,0.22)");
      gg.addColorStop(1, "rgba(120,112,98,0)");
      fx.fillStyle = gg; fx.beginPath(); fx.arc(lx, ly, lr, 0, 6.283); fx.fill();
    }
    for (var m = 0; m < 3200; m++) {
      var a2 = rnd() * 6.283, r2 = Math.pow(rnd(), 0.45);
      fx.fillStyle = rnd() > 0.42 ? "rgba(58,52,44,0.17)" : "rgba(198,190,176,0.13)";
      fx.beginPath();
      fx.arc(cxf + Math.cos(a2) * F * 0.35 * r2, cyf + Math.sin(a2) * F * 0.3 * r2, 0.5 + rnd() * 1.5, 0, 6.283);
      fx.fill();
    }
    spr.film = fc;

    var T = 128, nc = document.createElement("canvas");
    nc.width = nc.height = T;
    var nx = nc.getContext("2d"), id = nx.createImageData(T, T);
    for (var q = 0; q < id.data.length; q += 4) {
      var v = 120 + Math.random() * 135;
      id.data[q] = id.data[q + 1] = id.data[q + 2] = v;
      id.data[q + 3] = 22 + Math.random() * 26;
    }
    nx.putImageData(id, 0, 0);
    spr.noise = nc;
  }

  // ---- deterministic scatter ---------------------------------------------
  var flora = [], harmful = [], motes = [];
  function seed() {
    var s = 20260903;
    var rnd = function () { s = (s * 1664525 + 1013904223) % 4294967296; return s / 4294967296; };
    var gauss = function () { return (rnd() + rnd() + rnd() - 1.5) / 1.5; };
    for (var i = 0; i < 300; i++) {
      flora.push({ x: rnd(), y: rnd(), rank: rnd(), len: 9 + rnd() * 13, w: 3.4 + rnd() * 3.2,
        rot: rnd() * Math.PI, rod: rnd() > 0.42, ph: rnd() * Math.PI * 2, tone: rnd() });
    }
    var hubs = [
      { x: 0, y: 0, n: 62 }, { x: -0.30, y: -0.19, n: 22 }, { x: 0.19, y: 0.24, n: 20 },
      { x: -0.16, y: 0.28, n: 16 }, { x: 0.26, y: -0.26, n: 14 }
    ];
    hubs.forEach(function (hb, hi) {
      for (var i = 0; i < hb.n; i++) {
        var tight = hi === 0 ? 1 : 0.62;
        harmful.push({ hx: hb.x, hy: hb.y, dx: gauss() * 0.085 * tight, dy: gauss() * 0.075 * tight,
          rank: hi === 0 ? rnd() : rnd() * 0.62, r: 3.2 + rnd() * 3.4, ph: rnd() * Math.PI * 2 });
      }
    });
    for (var j = 0; j < 40; j++) {
      motes.push({ dx: gauss() * 0.1, dy: gauss() * 0.09, r: 0.8 + rnd() * 1.6, ph: rnd() * 6.283 });
    }
  }

  // ---- layout -------------------------------------------------------------
  function layout() {
    var m = isMobile();
    caps.style.left = m ? "6vw" : "5vw";
    caps.style.width = m ? "88vw" : "min(46vw, 620px)";
    caps.style.top = m ? "27%" : "50%";
    for (var i = 0; i < caps.children.length; i++) {
      var body = caps.children[i].children[2];
      if (body) body.style.maxWidth = m ? "none" : "40ch";
    }
    meter.style.display = m ? "none" : (SHOW_METER ? "flex" : "none");
    scrim.style.background = m
      ? "linear-gradient(180deg, rgba(255,255,255,0.94) 0%, rgba(255,255,255,0.88) 34%, rgba(255,255,255,0.34) 62%, rgba(255,255,255,0.10) 100%)"
      : "linear-gradient(100deg, rgba(255,255,255,0.92) 0%, rgba(255,255,255,0.74) 34%, rgba(255,255,255,0.10) 62%, rgba(255,255,255,0) 100%)";
    rail.style.left = m ? "6vw" : "5vw";
    rail.style.bottom = "calc(4vh + var(--hx-cta, 84px))";
    rail.style.width = m ? "88vw" : "auto";
    rail.style.flexWrap = m ? "wrap" : "nowrap";
    rail.style.gap = m ? "8px" : "14px";
    var lab0 = rail.querySelector("[data-frame]");
    if (lab0) {
      lab0.style.marginLeft = m ? "0" : "12px";
      lab0.style.order = m ? "-1" : "0";
      lab0.style.width = m ? "100%" : "auto";
      lab0.style.marginBottom = m ? "6px" : "0";
      lab0.style.whiteSpace = "nowrap";
    }
    var dts = rail.querySelectorAll("[data-dot]");
    for (var d0 = 0; d0 < dts.length; d0++) {
      dts[d0].style.flex = m ? "1 1 0" : "0 0 34px";
      dts[d0].style.width = m ? "auto" : "34px";
    }
    hint.style.bottom = "calc(4vh + var(--hx-cta, 84px))";
    hint.style.display = m ? "none" : "block";
  }
  function resize() {
    var d = Math.min(window.devicePixelRatio || 1, 2), r = cv.getBoundingClientRect();
    cv.width = Math.max(1, Math.round(r.width * d));
    cv.height = Math.max(1, Math.round(r.height * d));
    dpr = d; W = r.width; H = r.height;
    noisePat = null;
  }
  function progress() {
    var pin = root.querySelector("[data-hx=pin]");
    var vh = pin ? pin.getBoundingClientRect().height : window.innerHeight;
    var r = root.getBoundingClientRect(), span = r.height - vh;
    if (span <= 0) return 0;
    return Math.min(1, Math.max(0, -r.top / span));
  }
  function inView() {
    var r = root.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  // ---- render -------------------------------------------------------------
  function cover(img, alpha, zoom) {
    var z = zoom || 1, s = Math.max(W / img.width, H / img.height) * z;
    var dw = img.width * s, dh = img.height * s;
    ctx.save(); ctx.globalAlpha = alpha;
    ctx.drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
    ctx.restore();
  }

  function paint() {
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);
    var mob = isMobile();

    var zoom = track(p, [[0, 1.0], [0.09, 1.34], [1, 1.55]]);
    var soft = track(p, [[0, 0], [0.02, 0.2], [0.07, 1], [1, 1]]);
    if (plate) {
      ctx.save();
      if (soft > 0.02) ctx.filter = "blur(" + (soft * 5 * (Math.min(W, H) / 900)).toFixed(2) + "px) saturate(" + (1 - soft * 0.42).toFixed(2) + ")";
      cover(plate, 1, zoom);
      ctx.restore();
    } else { ctx.fillStyle = "#D9AE8C"; ctx.fillRect(0, 0, W, H); }

    ctx.fillStyle = "rgba(240,237,230," + (0.1 + 0.34 * soft).toFixed(3) + ")";
    ctx.fillRect(0, 0, W, H);

    // on mobile the copy sits top-left, so the colony drops into the lower half
    var cx = (mob ? 0.52 : 0.64) * W, cy = (mob ? 0.72 : 0.52) * H;
    var S = Math.min(W, H) / 900, px = Math.max(2.3, S * 2.6);

    var D = track(p, [[0, 0.62], [0.17, 0.62], [0.32, 0.26], [0.5, 0.16], [0.63, 0.24], [0.8, 0.74], [1, 1]]);
    var Hh = track(p, [[0, 0.1], [0.17, 0.12], [0.32, 0.5], [0.5, 0.9], [0.62, 0.72], [0.78, 0.2], [1, 0.07]]);
    var B = track(p, [[0, 0], [0.3, 0.06], [0.42, 0.95], [0.55, 1], [0.6, 0.72], [0.7, 0.06], [1, 0]]);

    for (var i = 0; i < flora.length; i++) {
      var f = flora[i];
      var v = Math.min(1, Math.max(0, (D - f.rank) / 0.09));
      if (v <= 0.01) continue;
      var x = f.x * W + Math.sin(t * 0.5 + f.ph) * 2.2 * S;
      var y = f.y * H + Math.cos(t * 0.42 + f.ph) * 2.2 * S;
      var sp = spr.flora[(f.rod ? 0 : 3) + Math.min(2, Math.floor(f.tone * 3))];
      var size = f.rod ? f.len * px * 2.0 : f.w * px * 3.9;
      ctx.save(); ctx.translate(x, y);
      ctx.rotate(f.rot + Math.sin(t * 0.2 + f.ph) * 0.1);
      ctx.globalAlpha = v;
      ctx.drawImage(sp, -size / 2, -size / 2, size, size);
      ctx.restore();
    }

    var pull = 1 - 0.32 * smooth((p - 0.24) / 0.26);
    var merge = smooth((p - 0.33) / 0.13);
    for (var j = 0; j < harmful.length; j++) {
      var m2 = harmful[j];
      var hv = Math.min(1, Math.max(0, (Hh - m2.rank) / 0.12));
      if (hv <= 0.01) continue;
      var hx = m2.hx * (1 - merge), hy = m2.hy * (1 - merge);
      var mx = cx + (hx + m2.dx * pull) * W + Math.sin(t * 0.7 + m2.ph) * 1.6 * S;
      var my = cy + (hy + m2.dy * pull) * H + Math.cos(t * 0.6 + m2.ph) * 1.6 * S;
      var hs = m2.r * px * 3.6;
      ctx.save(); ctx.translate(mx, my); ctx.rotate(m2.ph + t * 0.05);
      ctx.globalAlpha = hv;
      ctx.drawImage(spr.harm[Math.floor(m2.ph) % 3], -hs / 2, -hs / 2, hs, hs);
      ctx.restore();
    }
    ctx.globalAlpha = 1;

    if (B > 0.01 && spr.film) {
      var fs = Math.min(W, H) * 1.02 * (0.78 + 0.22 * B);
      var fx0 = cx - fs / 2, fy0 = cy - fs / 2;
      var front = p > 0.5 ? cx - fs * 0.55 + track(p, [[0.5, 0], [0.68, 1.25]]) * fs : -1e9;
      var strips = 26, sw = fs / strips;
      for (var k = 0; k < strips; k++) {
        var sx = fx0 + k * sw;
        var a = B * (1 - smooth((front - sx) / (fs * 0.1)));
        if (a <= 0.01) continue;
        ctx.save();
        ctx.beginPath(); ctx.rect(sx, fy0, sw + 1, fs); ctx.clip();
        ctx.globalAlpha = a;
        ctx.drawImage(spr.film, fx0, fy0, fs, fs);
        ctx.restore();
      }
      ctx.globalAlpha = 1;
    }

    var R = smooth((p - 0.82) / 0.16);
    if (R > 0.01) {
      var gr = ctx.createRadialGradient(W * 0.5, H * 0.5, 0, W * 0.5, H * 0.5, Math.max(W, H) * 0.7);
      gr.addColorStop(0, "rgba(255,255,255," + (0.16 * R).toFixed(3) + ")");
      gr.addColorStop(1, "rgba(70,93,56," + (0.09 * R).toFixed(3) + ")");
      ctx.fillStyle = gr; ctx.fillRect(0, 0, W, H);
    }

    var E = smooth((p - 0.5) / 0.08) * (1 - smooth((p - 0.64) / 0.07));
    if (E > 0.01) {
      var span = Math.min(W, H) * 0.34;
      var ef = cx - span + track(p, [[0.5, 0], [0.66, 2.2]]) * span;
      var eg = ctx.createLinearGradient(ef - span * 0.5, 0, ef + span * 0.22, 0);
      eg.addColorStop(0, "rgba(255,255,255,0)");
      eg.addColorStop(0.7, "rgba(255,255,255," + (0.3 * E).toFixed(3) + ")");
      eg.addColorStop(1, "rgba(255,255,255,0)");
      ctx.fillStyle = eg; ctx.fillRect(0, 0, W, H);
      var rise = track(p, [[0.5, 0], [0.7, 1]]);
      for (var n = 0; n < motes.length; n++) {
        var mo = motes[n];
        ctx.globalAlpha = 0.5 * E * (1 - rise);
        ctx.fillStyle = "#F4F2EE";
        ctx.beginPath();
        ctx.arc(cx + mo.dx * W + Math.sin(t + mo.ph) * 6 * S, cy + mo.dy * H - rise * 60 * S, mo.r * px, 0, 6.283);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
    }

    if (intro) {
      var ia = 1 - smooth((p - 0.045) / 0.075);
      if (ia > 0.002) cover(intro, ia, 1 + 0.06 * smooth(p / 0.11));
    }

    if (spr.noise) {
      if (!noisePat) noisePat = ctx.createPattern(spr.noise, "repeat");
      ctx.save();
      ctx.globalAlpha = 0.5;
      ctx.fillStyle = noisePat;
      ctx.translate((t * 7) % 128 - 128, (t * 5) % 128 - 128);
      ctx.fillRect(0, 0, W + 256, H + 256);
      ctx.restore();
      ctx.globalAlpha = 1;
    }
  }

  function draw() {
    paint();
    var band = 1 / N;
    for (var i = 0; i < caps.children.length; i++) {
      var c = (i + 0.5) / N, d = (p - c) / band, o;
      if ((i === 0 && d < 0) || (i === N - 1 && d > 0)) o = 1;
      else o = smooth((0.62 - Math.abs(d)) / 0.24);
      caps.children[i].style.opacity = o.toFixed(3);
      caps.children[i].style.transform = "translateY(" + (-50 + Math.max(-1, Math.min(1, d)) * 3.5).toFixed(2) + "%)";
    }

    var div = track(p, [[0, 0.74], [0.14, 0.72], [0.34, 0.3], [0.52, 0.2], [0.64, 0.28], [0.82, 0.62], [1, 0.88]]);
    var path = track(p, [[0, 0.12], [0.14, 0.16], [0.34, 0.46], [0.52, 0.74], [0.64, 0.4], [0.82, 0.18], [1, 0.1]]);
    meter.style.opacity = smooth(p / 0.08).toFixed(3);
    var df = meter.querySelector("[data-div-fill]"), dn = meter.querySelector("[data-div-num]");
    var pf = meter.querySelector("[data-path-fill]"), pn = meter.querySelector("[data-path-num]");
    if (df) df.style.width = (div * 100).toFixed(1) + "%";
    if (dn) dn.textContent = Math.round(div * 100);
    if (pf) pf.style.width = (path * 100).toFixed(1) + "%";
    if (pn) pn.textContent = Math.round(path * 100);

    var active = Math.min(N - 1, Math.floor(p * N));
    var dots = rail.querySelectorAll("[data-dot]");
    for (var q = 0; q < dots.length; q++) {
      dots[q].style.background = q <= active ? (q >= 3 ? "#465D38" : "rgba(17,17,16,0.5)") : "rgba(17,17,16,0.14)";
    }
    var lab = rail.querySelector("[data-frame]");
    if (lab) lab.textContent = ((root.dataset.railLabels || "").split(",")[active] || "").trim();

    // a short tick as each beat lands, where the device supports it
    if (active !== lastBeat) {
      if (lastBeat !== -1 && isMobile() && navigator.vibrate) navigator.vibrate(8);
      lastBeat = active;
    }

    hint.style.opacity = (1 - smooth(p / 0.06)).toFixed(3);
  }

  function request() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; p = progress(); draw(); });
  }

  // the rail doubles as a control: each mark is a tap target that jumps to its beat
  var lastBeat = -1;
  function jumpTo(i) {
    var pin = root.querySelector("[data-hx=pin]");
    var vh = pin ? pin.getBoundingClientRect().height : window.innerHeight;
    var r = root.getBoundingClientRect(), span = r.height - vh;
    if (span <= 0) return;
    var pageTop = r.top + window.pageYOffset;
    window.scrollTo({ top: pageTop + span * ((i + 0.5) / N), behavior: "smooth" });
  }
  rail.style.pointerEvents = "auto";
  var railDots = rail.querySelectorAll("[data-dot]");
  for (var rd = 0; rd < railDots.length; rd++) {
    (function (el, i) {
      el.style.padding = "14px 0";
      el.style.backgroundClip = "content-box";
      el.style.cursor = "pointer";
      el.setAttribute("role", "button");
      el.setAttribute("tabindex", "0");
      el.setAttribute("aria-label", "Go to step " + (i + 1));
      el.addEventListener("click", function () { jumpTo(i); });
      el.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); jumpTo(i); }
      });
    })(railDots[rd], rd);
  }

  seed();
  makeSprites();
  resize();
  layout();

  if (PLATE_SRC) {
    var im = new Image();
    im.onload = function () { plate = im; request(); };
    im.src = PLATE_SRC;
  }
  if (INTRO_SRC) {
    var ii = new Image();
    ii.onload = function () { intro = ii; request(); };
    ii.src = INTRO_SRC;
  }

  var loop = function () {
    root._hxLoop = requestAnimationFrame(loop);
    if (!inView()) return;
    p = progress();
    t = performance.now() / 1000;
    draw();
  };
  loop();

  window.addEventListener("scroll", request, { passive: true });
  window.addEventListener("resize", function () { resize(); layout(); request(); });
  p = progress();
  request();

  document.addEventListener("shopify:section:unload", function (e) {
    if (e.target === root.parentNode || e.target.contains(root)) cancelAnimationFrame(root._hxLoop);
  });
};
